<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option>{{ overrideEmptyOption !== '' ? overrideEmptyOption : '' }}</lcs-option>
      } @for (logLevel of logLevels | async; track trackBy(logLevel)) {
      <lcs-option [value]="logLevel" id="lcs-option-id-{{ logLevel.logLevelId }}">
         {{ logLevel.logLevelId }}
      </lcs-option>
      }
   </div>
</ng-template>
